import React, { useState } from 'react';
import { DialogContent, DialogContentText, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import Modal from './modal';
import ButtonsContainer from 'shared/lib/components/controls/buttons/buttonsContainer';
import SecondaryButton from 'shared/lib/components/controls/buttons/secondaryButton';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';

export default observer(function WarningModal({
  isOpen,
  mainText,
  secondText,
  onCancel,
  onContinue,
  continueText = 'Удалить',
  cancelText = 'Отмена',
}: {
  isOpen: boolean;
  mainText: string;
  secondText?: string;
  onCancel: () => void;
  onContinue: () => void;
  continueText?: string;
  cancelText?: string;
}): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal isOpen={isOpen} handleClose={onCancel}>
      <Typography variant="f24">{mainText}</Typography>
      {secondText && (
        <DialogContent sx={{ px: 0, pt: 0 }}>
          <DialogContentText>{secondText}</DialogContentText>
        </DialogContent>
      )}
      <ButtonsContainer>
        <SecondaryButton onClick={onCancel}>{cancelText}</SecondaryButton>
        <PrimaryButton
          loading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            try {
              await onContinue();
              setIsLoading(false);
            } catch (e) {
              setIsLoading(false);
              throw e;
            }
          }}
        >
          {continueText}
        </PrimaryButton>
      </ButtonsContainer>
    </Modal>
  );
});
